import Message from "../../message";
import {useMainStore} from "@/store";

export default class InviteRevoked extends Message
{
    handle()
    {
        useMainStore().REMOVE_GUILD_INVITE(this.message.user_id);
    }
}
